export default __webpack_public_path__ + "static/media/me3.1c1acd72.jpg";